import React from "react";
import styled from "styled-components";

const colors = [
  "#413f62",
  "#e1be27",
  "#a67ed9",
  "#8cbb67",
  "#fa8046",
  "#828aef",
  "#78bec5",
  "#de4d78",
];
export const Ball = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 28px;
  background-color: ${(p) => colors[p.color]};
`;

export default function WinningStreak({ headline, description, backgrounds }) {
  return (
    <div
      style={{
        margin: "20px 0",
      }}
    >
      <p>
        <b>{headline} </b> – {description}.
      </p>
      <div
        style={{
          margin: "15px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "280px",
        }}
      >
        {backgrounds.map((b, i) => (
          <Ball color={b} key={i} />
        ))} 
      </div>
      <br />
    </div>
  );
}
 